import { render, staticRenderFns } from "./LearningWelcomeCard.vue?vue&type=template&id=39eaaeae&scoped=true"
import script from "./LearningWelcomeCard.vue?vue&type=script&lang=js"
export * from "./LearningWelcomeCard.vue?vue&type=script&lang=js"
import style0 from "./LearningWelcomeCard.vue?vue&type=style&index=0&id=39eaaeae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eaaeae",
  null
  
)

export default component.exports